// extracted by mini-css-extract-plugin
module.exports = {"Card":"NewQuoteSegmentCard_Card__sTQ8C","Quote":"NewQuoteSegmentCard_Quote__3UgHn","BottomLine":"NewQuoteSegmentCard_BottomLine__3cEgj","Cited":"NewQuoteSegmentCard_Cited__1wiDf"};